import Home from 'assets/images/home.svg';
import Stats from 'assets/images/stats.svg';
import Risto from 'assets/images/risto.svg';
import Users from 'assets/images/users.svg';
import UsersStatistics from 'assets/images/user-statistics.svg';
import RestaurantsIcon from 'assets/images/super_admin_restaurants_icon.svg';
import Percentage from 'assets/images/percentage.svg';
import NotificationBell from 'assets/images/notification-bell.svg';
import Reservations from 'assets/images/reservations.svg';
import AllBonuses from 'assets/images/all_bonuses.svg';
import GoBack from 'assets/images/go_back.svg';
import Help from 'assets/images/help.svg';
import GenerateQr from 'assets/images/qr-generate.svg';
import User from 'assets/images/user.svg';
import StarIcon from 'assets/images/StarIcon.svg';
import Register from 'assets/images/register.svg';
import ArrowRight from 'assets/images/arrow-right.svg';
import FattureRight from 'assets/images/fatture.svg';
import { FaStripe } from 'react-icons/fa';
import { GrSystem } from 'react-icons/gr';
import { MdSettingsSystemDaydream } from 'react-icons/md';

const urlPrefix = '/';

import routeCodes from './constants/route-codes';

const menuItems = {
  superAdmin: {
    main: [
      {
        img: Home,
        label: 'Dashboard',
        href: `${urlPrefix}`,
      },
      {
        img: UsersStatistics,
        label: 'Comportamento utente',
        href: routeCodes.userStatistic,
      },
      {
        img: RestaurantsIcon,
        label: 'Ristoratori / Produttori',
        href: routeCodes.restaurants,
      },
      {
        img: Percentage,
        label: 'Campagne promozionali',
        href: routeCodes.bonuses,
      },
      {
        img: FattureRight,
        label: 'Fatture',
        href: routeCodes.bonusesRestaurants,
      },
    ],
    footer: [
      {
        img: User,
        label: 'Amministrazione',
        suffix: ArrowRight,
        href: `${urlPrefix}administration`,
      },
    ],
  },

  main: [
    {
      img: Home,
      label: 'Home',
      href: `${urlPrefix}`,
    },
    {
      img: Reservations,
      label: 'Prenotazioni',
      href: routeCodes.reservations,
    },

    {
      img: NotificationBell,
      label: 'Reminder Prenotazioni',
      href: routeCodes.reminder,
    },
    {
      img: Risto,
      label: 'Menù',
      href: `${urlPrefix}menu`,
      onClick: 'menuStep',
    },
    {
      img: Users,
      label: 'Team',
      href: `${urlPrefix}team`,
    },
    {
      img: Stats,
      label: 'Statistiche',
      href: `${urlPrefix}statistics`,
    },
    {
      img: GoBack,
      label: 'Impostazioni',
      href: routeCodes.settings,
    },

    // {
    //   img: Percentage,
    //   label: 'Offerte',
    //   href: routeCodes.offers,
    // },
    // {
    //   img: AllBonuses,
    //   label: 'Buoni RistoraBergamo',
    //   href: routeCodes.allBonuses,
    // },
    // {
    //   icon: <MdSettingsSystemDaydream size={20} color='#FF7828' />,
    //   label: 'Ipratico',
    //   href: routeCodes.ipratico,
    // },
    // {
    //   img: Register,
    //   label: 'Registro COVID-19',
    //   href: routeCodes.register,
    // },
    // {
    //   icon: <FaStripe size={20} />,
    //   label: 'Stripe',
    //   clickable: true,
    // },
    // {
    //   img: GenerateQr,
    //   label: 'Genera QR code',
    //   href: routeCodes.generateQR,
    // },
  ],

  footer: [
    {
      img: StarIcon,
      label: 'Passa a Gestione avanzata',
      onClick: 'handleOpenAdvancedModal',
    },
    {
      img: Help,
      label: 'Help',
      href: routeCodes.help,
    },
    {
      img: User,
      label: 'Profilo',
      suffix: ArrowRight,
      href: `${urlPrefix}profile`,
    },
  ],
};

export default menuItems;
